import React from 'react';

const QuotePage = () => (
  <div>
    <h1>Quote</h1>
    <div className="m-5">
      <cite className="h4" cite="https://www.childup.com/blog/math-is-not-just-about-numbers-and-equations-its-about-learning-and-understanding#:~:text=As%20William%20Thurston%20said%2C%20%E2%80%9Cmathematics,be%20in%20the%20long%20run.&text=A%20mathematical%20mindset%20allows%20us%20to%20look%20at%20things%20logically.">
        &quot;Mathematics is not about numbers, equations,
        or algorithms. It is about understanding.&quot;
      </cite>
      <span className="h4 ms-2">-William Paul Thurston</span>
    </div>
  </div>
);

export default QuotePage;
